import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    starttime: {
      validations: []
    },    
    theme: {
      validations: [
        { type: 'required', message: 'Please select an item in the list.' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' }
      ]
    },
    eventextra1: {
      validations: []
    },   
    eventextra2: {
      validations: []
    },   
    reference: {
      validations: []
    },   
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event:*',
            options: [
              { label: 'Wedding' , value: 'Wedding'},
              { label: 'Birthday Party', value: 'Birthday Party'},
              { label: 'Corporate Event', value: 'Corporate Event'},
              { label: 'Social Event', value: 'Social Event'},
              { label: 'Cultural Event' , value: 'Cultural Event'},
              { label: 'Charity Ball', value: 'Charity Ball'},
              { label: 'School Formal', value: 'School Formal'},
              { label: 'Sangeet/Mendhi Night', value: 'Sangeet/Mendhi Night'}
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:*',
            mapping: 'plannedguestcount'
          },
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'small',
            label: 'Event Date:*',
            mapping: 'eventDate'
          }
        ]
      },   
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Duration:',
            options: [
              { label: '4 Hours' , value: '4 Hours'},
              { label: '5 Hours', value: '5 Hours'},
              { label: 'Full Day (8 Hours)', value: 'Full Day (8 Hours)'}
            ],
            mapping: 'eventextra1'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Style:',
            options: [
              { label: 'Banquet' , value: 'Banquet'},
              { label: 'Buffet', value: 'Buffet'},
              { label: 'Cocktail', value: 'Cocktail'},
              { label: 'Don\'t know yet', value: 'Don\'t know yet' }
            ],
            mapping: 'eventextra2'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'small',
            label: 'Event Start Time:',
            options: [
              { label: '6:00AM'  , value: '06:00:00'},
              { label: '6:30AM'  , value: '06:30:00'}, 
              { label: '7:00AM'  , value: '07:00:00'},
              { label: '7:30AM'  , value: '07:30:00'},
              { label: '8:00AM'  , value: '08:00:00'},
              { label: '8:30AM'  , value: '08:30:00'},
              { label: '9:00AM'  , value: '09:00:00'},
              { label: '9:30AM'  , value: '09:30:00'},
              { label: '10:00AM' , value: '10:00:00'},
              { label: '10:30AM' , value: '10:30:00'},
              { label: '11:00AM' , value: '11:00:00'},
              { label: '11:30AM' , value: '11:30:00'},
              { label: '12:00PM' , value: '12:00:00'},
              { label: '12:30PM' , value: '12:30:00'},
              { label: '1:00PM'  , value: '13:00:00'},
              { label: '1:30PM'  , value: '13:30:00'},
              { label: '2:00PM'  , value: '14:00:00'},
              { label: '2:30PM'  , value: '14:30:00'},
              { label: '3:00PM'  , value: '15:00:00'},
              { label: '3:30PM'  , value: '15:30:00'},
              { label: '4:00PM'  , value: '16:00:00'},
              { label: '4:30PM'  , value: '16:30:00'},
              { label: '5:00PM'  , value: '17:00:00'},
              { label: '5:30PM'  , value: '17:30:00'},
              { label: '6:00PM'  , value: '18:00:00'},
              { label: '6:30PM'  , value: '18:30:00'},
              { label: '7:00PM'  , value: '19:00:00'},
              { label: '7:30PM'  , value: '19:30:00'},
              { label: '8:00PM'  , value: '20:00:00'},
              { label: '8:30PM'  , value: '20:30:00'},
              { label: '9:00PM'  , value: '21:00:00'},
              { label: '9:30PM'  , value: '21:30:00'},
              { label: '10:00PM' , value: '22:00:00'}, 
              { label: '10:30PM' , value: '22:30:00'}, 
              { label: '11:00PM' , value: '23:00:00'}, 
              { label: '11:30PM' , value: '23:30:00'}, 
              { label: '12:00AM' , value: '24:00:00'}, 
              { label: '12:30AM' , value: '24:30:00'}, 
              { label: '1:00AM'  , value: '01:00:00'}, 
              { label: '1:30AM'  , value: '01:30:00'}, 
              { label: '2:00AM'  , value: '02:00:00'} 
            ],
            mapping: 'starttime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?:',
            options: [
              { label: 'Repeat Client' , value: 'Repeat Client'},
              { label: 'Google', value: 'Google'},
              { label: 'Attended an event', value: 'Attended an event'},
              { label: 'Referral', value: 'Referral' },
              { label: 'Walk in' , value: 'Walk in'},
              { label: 'Mailing', value: 'Mailing'},
              { label: 'Yellow Pages', value: 'Yellow Pages'},
              { label: 'Cold Contact', value: 'Cold Contact' },
              { label: 'Wedding Planner', value: 'Wedding Planner' },
              { label: 'Advertisement' , value: 'Advertisement'},
              { label: 'Mailing', value: 'Mailing'},
              { label: 'Hotel Reference', value: 'Hotel Reference'},
              { label: 'Other Hotel', value: 'Other Hotel' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'reference'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Your Message:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Concord Function Centre Contact Form',
    formId: '349',
    clientKey: '04003DEA-4215-40C9-A173-1CDFBBD1ED48',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for your inquiry! A member of our team will contact you shortly.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/concordfunctioncenter/form_structure.js